import { useEffect } from 'react'

export default function SourcingCapabilities() {
  useEffect(() => {
    document.title = 'Environmental Fabrication & Equipment Supply Capabilities | Yixing'
  }, [])

  return (
    <div className="page">
      <section className="page-header">
        <p className="eyebrow">MANUFACTURING SOURCE BY EQUIPMENT SCOPE</p>
        <h1>Manufacturing & Equipment Supply Capabilities</h1>
        <p>Grace's family-owned factory and the specialist partner route are stated separately so customers know who produces each equipment package.</p>
      </section>

      <section className="page-content">
        <h2>Grace's Family-Owned Factory</h2>
        <p>Stainless Steel & Carbon Steel Manufacturing by Grace's Family Factory</p>
        <p>Grace's family owns and operates the manufacturing facility in Yixing. The factory produces project-specific stainless steel and carbon steel equipment and fabricated components.</p>
        <p>Project-specific equipment, frames, skids, tanks, housings and fabricated components can be reviewed against customer drawings and specifications.</p>
        <p>Before quotation, the responsible factory confirms materials, dimensions, process requirements, documentation, inspection scope and production limitations for the project.</p>

        <h2>Selected Specialist Partners</h2>
        <p>For FRP, PP, membrane, wastewater, sludge handling and other specialist equipment, Grace coordinates selected manufacturing partners according to the confirmed equipment scope.</p>
      </section>
    </div>
  )
}
